import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateTiposVerifactuRegimen () {
  return [
    {
      id: '01',
      long: i18n.t('verifactu.verifactu_regimen.01'),
      name: i18n.t('verifactu.verifactu_regimen.01')
    },
    {
      id: '02',
      long: i18n.t('verifactu.verifactu_regimen.02'),
      name: i18n.t('verifactu.verifactu_regimen.02')
    },
    {
      id: '03',
      long: i18n.t('verifactu.verifactu_regimen.03_long'),
      name: i18n.t('verifactu.verifactu_regimen.03')
    },
    {
      id: '04',
      long: i18n.t('verifactu.verifactu_regimen.04_long'),
      name: i18n.t('verifactu.verifactu_regimen.04')
    },
    {
      id: '05',
      long: i18n.t('verifactu.verifactu_regimen.05_long'),
      name: i18n.t('verifactu.verifactu_regimen.05')
    },
    {
      id: '06',
      long: i18n.t('verifactu.verifactu_regimen.06_long'),
      name: i18n.t('verifactu.verifactu_regimen.06')
    },
    {
      id: '07',
      long: i18n.t('verifactu.verifactu_regimen.07_long'),
      name: i18n.t('verifactu.verifactu_regimen.07')
    },
    {
      id: '08',
      long: i18n.t('verifactu.verifactu_regimen.08_long'),
      name: i18n.t('verifactu.verifactu_regimen.08')
    },
    {
      id: '09',
      long: i18n.t('verifactu.verifactu_regimen.09_long'),
      name: i18n.t('verifactu.verifactu_regimen.09')
    },
    {
      id: '10',
      long: i18n.t('verifactu.verifactu_regimen.10_long'),
      name: i18n.t('verifactu.verifactu_regimen.10')
    },
    {
      id: '11',
      long: i18n.t('verifactu.verifactu_regimen.11_long'),
      name: i18n.t('verifactu.verifactu_regimen.11')
    },
    {
      id: '14',
      long: i18n.t('verifactu.verifactu_regimen.14_long'),
      name: i18n.t('verifactu.verifactu_regimen.14')
    },
    {
      id: '15',
      long: i18n.t('verifactu.verifactu_regimen.15_long'),
      name: i18n.t('verifactu.verifactu_regimen.15')
    },
    {
      id: '17',
      long: i18n.t('verifactu.verifactu_regimen.17_long'),
      name: i18n.t('verifactu.verifactu_regimen.17')
    },
    {
      id: '18',
      long: i18n.t('verifactu.verifactu_regimen.18_long'),
      name: i18n.t('verifactu.verifactu_regimen.18')
    },
    {
      id: '19',
      long: i18n.t('verifactu.verifactu_regimen.19_long'),
      name: i18n.t('verifactu.verifactu_regimen.19')
    },
    {
      id: '20',
      long: i18n.t('verifactu.verifactu_regimen.20_long'),
      name: i18n.t('verifactu.verifactu_regimen.20')
    },
  ]
}

function GenerateTiposVerifactuFacturas () {
  return [
    {
      id: 'F1',
      name: i18n.t('verifactu.invoice_type.f1')
    },
    {
      id: 'F2',
      name: i18n.t('verifactu.invoice_type.f2')
    },
    {
      id: 'F3',
      name: i18n.t('verifactu.invoice_type.F3')
    },
  ]
}

function GenerateTiposVerifactuFacturasRectificativas () {
  return [
    {
      id: 'R1',
      name: i18n.t('verifactu.invoice_type.R1')
    },
    {
      id: 'R2',
      name: i18n.t('verifactu.invoice_type.R2')
    },
    {
      id: 'R3',
      name: i18n.t('verifactu.invoice_type.R3')
    },
    {
      id: 'R4',
      name: i18n.t('verifactu.invoice_type.R4')
    },
    {
      id: 'R5',
      name: i18n.t('verifactu.invoice_type.R5')
    }
  ]
}

function GenerateTiposVerifactuExenta () {
  return [
    {
      id: 'E1',
      name: i18n.t('verifactu.verifactu_exenta_type.E1')
    },
    {
      id: 'E2',
      name: i18n.t('verifactu.verifactu_exenta_type.E2')
    },
    {
      id: 'E3',
      name: i18n.t('verifactu.verifactu_exenta_type.E3')
    },
    {
      id: 'E4',
      name: i18n.t('verifactu.verifactu_exenta_type.E4')
    },
    {
      id: 'E5',
      name: i18n.t('verifactu.verifactu_exenta_type.E5')
    },
    {
      id: 'E6',
      name: i18n.t('verifactu.verifactu_exenta_type.E6')
    },
  ]
}

function GenerateTiposVerifactuNoExenta () {
  return [
    {
      id: 'S1',
      name: i18n.t('verifactu.verifactu_no_exenta_type.S1') 
    },
    {
      id: 'S2',
      name: i18n.t('verifactu.verifactu_no_exenta_type.S2') 
    },
  ]
}

function GenerateTiposVerifactuNoSujeta () {
  return [
    {
      id: 'N1',
      name: i18n.t('verifactu.verifactu_no_sujeta_type.N1')
    },
    {
      id: 'N2',
      name: i18n.t('verifactu.verifactu_no_sujeta_type.N2')
    },
  ]
}

function GenerateTiposVerifactuDashboard () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.verifactu_dashboard_type.alta')
    },
    {
      id: 2,
      name: i18n.t('tipos.verifactu_dashboard_type.rectificativa')
    },
    {
      id: 3,
      name: i18n.t('tipos.verifactu_dashboard_type.anulacion')
    },
  ]
}



function TIPOS_VERIFACTU_REGIMEN (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_REGIMEN', GenerateTiposVerifactuRegimen)
}

function TIPOS_VERIFACTU_FACTURAS (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_FACTURAS', GenerateTiposVerifactuFacturas)
}

function TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS', GenerateTiposVerifactuFacturasRectificativas)
}

function TIPOS_VERIFACTU_EXENTA (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_EXENTA', GenerateTiposVerifactuExenta)
}

function TIPOS_VERIFACTU_NO_EXENTA (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_NO_EXENTA', GenerateTiposVerifactuNoExenta)
}

function TIPOS_VERIFACTU_NO_SUJETA (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_NO_SUJETA', GenerateTiposVerifactuNoSujeta)
}

function TIPOS_VERIFACTU_DASHBOARD (state) {
  return configHelper.getConfig(state, 'TIPOS_VERIFACTU_DASHBOARD', GenerateTiposVerifactuDashboard)
}

  
export { TIPOS_VERIFACTU_REGIMEN, TIPOS_VERIFACTU_FACTURAS, TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS, TIPOS_VERIFACTU_EXENTA, TIPOS_VERIFACTU_NO_EXENTA, TIPOS_VERIFACTU_NO_SUJETA, TIPOS_VERIFACTU_DASHBOARD }
